import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';
import type { GetUserClubsAndScheduledGamesResponse } from '@swf/generated/types/api/v0/SwHomeGames';
import type { HomeGamesWidgetModel } from '@swf/poker';
import { PKR_LOADERS } from '@swf/poker';

export const fetchInitialData = async (
  _: undefined,
  { request, dispatch, widget: { id } }: WidgetEffectParams<void>
): Promise<void> => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[id];

  try {
    const { body } = await request<GetUserClubsAndScheduledGamesResponse>({
      service: 'homeGames.userClubsAndScheduledGamesRequest'
    });

    if (body.success) {
      widgetDispatch.setUserClubsAndGames(body);
    }
  } catch (error) {
    widgetDispatch.setError({ level: 'critical', value: true });
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName: PKR_LOADERS.initial });
  }
};
